const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;
const addDiscountColumn = (tableWrapper) => {
  const table = tableWrapper.querySelector(".quantity_break_table");
  const thead = table.querySelector("thead tr");
  const tbody = table.querySelector("tbody");

  const productFormId = document
    .querySelector(".product__info-container")
    ?.getAttribute("bss-b2b-product-form-id");
  if (productFormId) {
    const productFormStorage =
      BSS_B2B?.storage?.productFormStorage?.get(productFormId);
    if (productFormStorage && productFormStorage.appliedQB) {
      const qtyTable = productFormStorage.appliedQB.qty_table;
      const originalPrice = productFormStorage.price;
      const discountTh = document.createElement("th");
      discountTh.textContent = "Discount";
      thead.appendChild(discountTh);
      document.querySelector(".quantity_break_table th").innerHTML = "Quantity in Pack"
      qtyTable.forEach((qbRow) => {
        let discountPercent = 0;
        const rowIdAttribute = qbRow.id + "-" + qbRow.rule_id;
        const qbRowHTML = document.querySelector(
          `.bss-b2b-qty-table-row[row-id="${rowIdAttribute}"]`
        );
        if (qbRow.discount_type === 2) {
          discountPercent = qbRow.discount_value;
        } else if (qbRow.discount_type === 0) {
          discountPercent =
            ((originalPrice - qbRow.discount_value * 100) * 100) /
            originalPrice;
        } else if (qbRow.discount_type === 1) {
          discountPercent = (qbRow.discount_value * 10000) / originalPrice;
        }
        if (qbRowHTML) {
          const discountTd = document.createElement("td");
          discountTd.textContent = `${discountPercent}%`;
          qbRowHTML.appendChild(discountTd);
        }
      });
    }
  }
};
if (pageType === "product" && BSS_B2B) {
  let counter = 0;
  let selector = ".bss-b2b-cart-item-qty-table";
  const interval = setInterval(() => {
    const tableWrapper = document.querySelector(selector);
    if (tableWrapper) {
      clearInterval(interval);
      addDiscountColumn(tableWrapper);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
}
